import { createAction } from 'typesafe-actions';

import {
  Clear,
  ResetPagesRendered,
  SetPageRendered,
  SetPagesForFile,
  SetPdfFiles,
} from './actionTypes';

export interface SetPdfFilesPayload {
  documentId: string;
  files: string[];
}

export interface SetPagesForFilePayload {
  documentId: string;
  pdfFile: string;
  pagesNumber: number;
}

export interface SetPageRenderedPayload {
  documentId: string;
  pageNumber: number;
}

export const setPdfFiles = createAction(
  SetPdfFiles,
  (payload: SetPdfFilesPayload) => payload,
)();

export const setPagesForFile = createAction(
  SetPagesForFile,
  (payload: SetPagesForFilePayload) => payload,
)();

export const resetPagesRendered = createAction(
  ResetPagesRendered,
  (documentId: string) => documentId,
)();

export const setPageRendered = createAction(
  SetPageRendered,
  (payload: SetPageRenderedPayload) => payload,
)();

export const clearDocumentInteract = createAction(
  Clear,
  (documentId: string) => documentId,
)();
